// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import reportQry from './metaData/reportQry'
export default {
  state: reportQry,
  actions
}
